<template>
  <div class="role-actions-cell">
    <Button class="square xs outline red" icon="bi-trash" @click="onDelete"></Button>
  </div>
</template>

<script lang="ts" setup>
import Button from '@/components/global/Button.vue';

const props = defineProps({
  params: Object, // injected by AG Grid, contains `data`, `api`, etc.
});

function onDelete() {
  props.params.onDelete(props.params.data);
}
</script>

<style lang="scss">
.role-actions-cell {
  display: flex !important;
  flex-direction: row;
  align-items: center;
  justify-content: end;
  gap: 4px;
  height: 100%;
}

</style>